"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _QuoteResponse = _interopRequireDefault(require("../model/QuoteResponse"));
var _Rfq = _interopRequireDefault(require("../model/Rfq"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
* PublicRfqs service.
* @module api/PublicRfqsApi
* @version 0.0.1
*/
var PublicRfqsApi = exports["default"] = /*#__PURE__*/function () {
  /**
  * Constructs a new PublicRfqsApi. 
  * @alias module:api/PublicRfqsApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function PublicRfqsApi(apiClient) {
    _classCallCheck(this, PublicRfqsApi);
    this.apiClient = apiClient || _ApiClient["default"].instance;
  }

  /**
   * Callback function to receive the result of the publicRfqsIdGet operation.
   * @callback module:api/PublicRfqsApi~publicRfqsIdGetCallback
   * @param {String} error Error message, if any.
   * @param {module:model/Rfq} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * @param {Number} id 
   * @param {Object} opts Optional parameters
   * @param {String} opts.linkId 
   * @param {String} opts.code 
   * @param {module:api/PublicRfqsApi~publicRfqsIdGetCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link module:model/Rfq}
   */
  return _createClass(PublicRfqsApi, [{
    key: "publicRfqsIdGet",
    value: function publicRfqsIdGet(id, opts, callback) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling publicRfqsIdGet");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {
        'link_id': opts['linkId'],
        'code': opts['code']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _Rfq["default"];
      return this.apiClient.callApi('/public_rfqs/{id}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the publicRfqsIdPost operation.
     * @callback module:api/PublicRfqsApi~publicRfqsIdPostCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {String} opts.linkId 
     * @param {String} opts.code 
     * @param {module:model/QuoteResponse} opts.quoteResponse 
     * @param {module:api/PublicRfqsApi~publicRfqsIdPostCallback} callback The callback function, accepting three arguments: error, data, response
     */
  }, {
    key: "publicRfqsIdPost",
    value: function publicRfqsIdPost(id, opts, callback) {
      opts = opts || {};
      var postBody = opts['quoteResponse'];
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling publicRfqsIdPost");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {
        'link_id': opts['linkId'],
        'code': opts['code']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json', 'text/json', 'application/_*+json'];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/public_rfqs/{id}', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
  }]);
}();